import { ReactComponent as ExclamationCircle } from '@/assets/svgs/exclamation-circle.svg'
import { ReactComponent as IconCheckHistory } from '@/assets/svgs/icon-check-history.svg'
import { ReactComponent as IconPersona } from '@/assets/svgs/icon-persona.svg'
import { NavLink } from '@/lib/router-dom/index'
import classname from 'classnames'
import PropTypes from 'prop-types'

const SelectorBox = ({id, active, label, description, submit, hideSelect=false, removedList = false, Icon = false, available }) => {
	const selectorClass = classname({
		'selector-box-5': true,
		'selector-box-5--active': active,
		'selector-box-5--cursor': hideSelect,
		'selector-box-5--removed': removedList,
		'selector-box-5--disable': available === 'comingSoon' && true,
		'selector-box-5--hide': available === 'noAgent',
	})

	return (
		<div className={selectorClass} onClick={submit ? submit : null}>
			<div className="selector-box-5__top">
				<div className="selector-box-5__icon">
					{
						!Icon && (
							<IconPersona />
						)
					}
					{
						Icon && (
							<Icon />
						)
					}

				</div>
			</div>
			<div className="selector-box-5__content">
				<div className="selector-box-5__label" id={id} data-testid={id}>{label}</div>
				<div className="selector-box-5__desc">{description}</div>
			</div>
			{
			available === 'comingSoon' &&
				<div className="selector-box-5__comingSoon">
					<div className="icon" ><IconCheckHistory /></div>
					<div className="desc">Coming Soon...</div>
				</div>
			}
			{
			available === 'noPrincipals' &&
				<div className="selector-box-5__noPrincipals">
					<div className="icon" ><ExclamationCircle /></div>
					<div className="desc">You have no principals added yet. <NavLink to="/use-cases/principal">Add Principal here</NavLink></div>
				</div>
			}
		</div>
	)
}

SelectorBox.propTypes = {
	id: PropTypes.string.isRequired,
	active: PropTypes.bool,
	label: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	submit: PropTypes.func,
	hideSelect: PropTypes.bool,
	removedList: PropTypes.bool,
	Icon: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
	available: PropTypes.oneOf(['', 'comingSoon', 'noAgent', 'noPrincipals'])
};

export default SelectorBox
